import { Report62Component } from "../../../components/SupportSystem/Reports/Report62Component";
// import { NavbarComponent } from "../../../components/share/NavbarComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function Report62Container() {
    const titleName = "สรุปรายงานผลการดำเนินงานกรมพัฒนาฝีมือแรงงานของผู้ได้รับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <Report62Component/>
            <Footer />
        </div>   
        // 
    )
    
}